import FragmentPage from '../core/FragmentPage';

export default class TerapiasPage extends FragmentPage {
  constructor(meta) {
    super('terapias', meta);
  }
}
